import { render, staticRenderFns } from "./userSelectBox.vue?vue&type=template&id=54a19d7e&scoped=true"
import script from "./userSelectBox.vue?vue&type=script&lang=js"
export * from "./userSelectBox.vue?vue&type=script&lang=js"
import style0 from "./userSelectBox.vue?vue&type=style&index=0&id=54a19d7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a19d7e",
  null
  
)

export default component.exports